import { Navigate } from 'react-router-dom';
import { DiscordLoginButton } from '@/components/auth/DiscordLoginButton';
import { Button } from '@/components/shared/Button';
import { Panel } from '@/components/shared/Panel';
import { useAuth } from '@/hooks/useAuth';

export function SignInPage(): JSX.Element {
  const { authMode, isLoading, isSignedIn, isApproved, needsOnboarding, login, previewPending } = useAuth();

  if (isLoading) {
    return (
      <div className="auth-page">
        <div className="auth-page__backdrop" />
        <Panel title="Loading session" description="Checking your Discord session and guild approval status." />
      </div>
    );
  }

  if (isSignedIn && needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  if (isSignedIn && isApproved) {
    return <Navigate to="/masses" replace />;
  }

  if (isSignedIn && !isApproved) {
    return <Navigate to="/pending-approval" replace />;
  }

  return (
    <div className="auth-page">
      <div className="auth-page__backdrop" />
      <Panel>
        <div className="auth-hero">
          <div className="auth-hero__content">
            <div className="auth-hero__copy">
              <p className="auth-hero__eyebrow">Private Albion Guild Portal</p>
              <h1 className="auth-hero__title">Woof Woof</h1>
              <p className="auth-hero__description">
                Mass signups, comp management, and guild coordination in one place.
              </p>
            </div>
            <div className="auth-hero__chips" aria-label="Portal highlights">
              <span className="auth-hero__chip">Discord Sign-In</span>
              <span className="auth-hero__chip">Guild Approval</span>
              <span className="auth-hero__chip">Live Mass Portal</span>
            </div>
          </div>
          <div className="auth-hero__action-panel">
            <div className="auth-hero__action-copy">
              <h2 className="auth-hero__action-title">Enter the portal</h2>
              <p className="auth-hero__action-description">Sign in with Discord to continue.</p>
            </div>
          <DiscordLoginButton onClick={login} />
          {authMode === 'mock' ? (
            <Button variant="secondary" fullWidth onClick={previewPending}>
              Preview Pending Approval Flow
            </Button>
          ) : null}
          </div>
        </div>
      </Panel>
    </div>
  );
}
